import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg'

export default CopyIcon
